import { trigger, transition, style, animate } from '@angular/animations';
import { Component, Input, OnDestroy, signal, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { faArrowRight, faClose, faFlag } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'eiq-flags',
  templateUrl: 'flags.component.html',
  styleUrls: ['./flags.component.scss'],
  animations: [
    trigger('animations', [
      transition(':enter', [
        style({
          opacity: 0,
          scale: 0.8
        }),
        animate(
          '0.15s ease-in-out',
          style({
            opacity: 1,
            scale: 1
          })
        )
      ]),
      transition(':leave', [
        style({
          opacity: 1,
          scale: 1
        }),
        animate(
          '0.15s ease-in-out',
          style({
            opacity: 0.8,
            scale: 0.8
          })
        )
      ])
    ])
  ]
})
export class FlagsComponent implements OnDestroy {
  @ViewChild('flagInfo', { static: true }) overlayContent!: TemplateRef<any>;

  @Input() flags = [];
  @Input() id: string;

  showFlags$ = signal(false);

  faArrowRight = faArrowRight;
  faClose = faClose;
  faFlag = faFlag;

  constructor(private router: Router) {}

  ngOnDestroy(): void {
    this.closeFlagsOverlay();
  }

  showFlagsOverlay(): void {
    this.showFlags$.set(true);
  }

  closeFlagsOverlay(): void {
    this.showFlags$.set(false);
  }
}
